import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faUser } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import formatRelativeDate from '@functions/formatRelativeDate'

import useArtworkReview from '@hooks/useArtworkReview'

import type { ArtworkReviewModel } from '@models/types'

interface ArtworkReviewProps {
  artworkReview: ArtworkReviewModel,
}

const ArtworkReview = (props: ArtworkReviewProps) => {
  const { artworkReview } = props

  const artworkReviewPayload = useArtworkReview(artworkReview)
  const {
    createdDateString,
    isApproved,
    user,
    userImage,
    status,
  } = artworkReviewPayload

  const userImageUrl = digObject(userImage, 'thumb_url', '')

  return (
    <ListItem boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }} disableHover forceBottomBorder>
      <Box width="auto" marginRight="medium">
        <UserProfileImage imageUrl={userImageUrl}>
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>
      </Box>

      <Box flexDirection="column">
        <Text fontWeight="bold" fontSize="xsmall">
          {/*
           // @ts-expect-error TS2339 */}
          {user.full_name}
        </Text>

        <Text
          color={isApproved ? 'green' : 'red'}
          fontSize="xsmall"
          fontWeight="bold"
          marginTop="medium"
          style={{ textTransform: 'capitalize' }}
        >
          {/*
           // @ts-expect-error TS2339 */}
          <FontAwesomeIcon icon={isApproved ? faCheck : faTimes} /> {status.title} Artwork
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {formatRelativeDate(createdDateString)}
        </Text>
      </Box>
    </ListItem>
  )
}

export default ArtworkReview
